export default __webpack_public_path__ + "static/media/sr_esp.8b9b288f.jpg";